export const paths = {
  NEW: 'new',
  EDIT: 'edit',
}

export const addressLinks = {
  newAddressLink: () => `/${paths.NEW}`,
  editAddressLink: (params: { addressId: string }) => `/${paths.EDIT}/${params.addressId}`,
}

export type AddressLinks = typeof addressLinks
